import React from 'react';
import css from './SaveSearchFilter.scss';
import NotificationMessage from '../common/NotificationMessage';


class SaveSearchFilter extends React.Component {

  render() {
    return (      
        <div className={css['save-search-filter']}>
          <NotificationMessage message="Saving Filters will store all of the filters you select below. The result may vary depending on updates in the student database." display={true} />
          <div className={css['topborder']}>
            <button role="button" aria-label="Add To My Saved Filters" className={css['button-save-filter']}><span className={css['plusicon']}>+</span> Add To My Saved Filters</button>
          </div>
        </div>      
    );
  }
}

export default SaveSearchFilter;
